module.exports = __webpack_public_path__ + "f4172650df407700f4cbe81cbd463484.svg";